"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkIcon = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const Link_context_1 = require("./Link.context");
const LinkIcon = ({ iconName, rotation, id, }) => {
    const { openInNewTab, theme } = (0, Link_context_1.useLink)();
    if (iconName === "OpenWindow" && !openInNewTab) {
        throw new Error("openInNewTab needs to be passed as props");
    }
    return (react_1.default.createElement(__1.Icon, { name: openInNewTab ? "OpenWindow" : iconName, size: 3, rotation: rotation, colour: theme === "light" ? "blue" : "white", title: openInNewTab ? "Opens in new tab" : undefined }));
};
exports.LinkIcon = LinkIcon;
//# sourceMappingURL=LinkIcon.js.map